import { Stack } from "@mui/material";
import { useState } from "react";
import { CampaignPurpose } from "../../types/enums";
import { Campaign } from "../../types/apiTypes";
import { ProductListItem } from "./ProductListItem";

type Props = {
  items: Campaign[];
};

export const DemoWrapper = ({ items }: Props) => {
  const [activeTab, setActiveTab] = useState<CampaignPurpose>(
    CampaignPurpose.sales,
  );

  const tabs = [
    { id: "sales", label: "Sales Demo" },
    { id: "demo", label: "Step-By-Step-Demo" },
  ];

  return (
    <Stack>
      <Stack direction="row">
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab.id;
          return (
            <span
              key={tab.id}
              onClick={() => setActiveTab(tab.id as any)}
              style={{
                cursor: "pointer",
                position: "relative",
                padding: "4px 16px 0 16px",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "26px",
                borderRadius: "6px",
                borderBottomLeftRadius: isActive ? "0" : "6px",
                borderBottomRightRadius: isActive ? "0" : "6px",
                backgroundColor: isActive ? "#2194D2" : "white",
                color: isActive ? "#fff" : "#2194D2",
              }}
            >
              {tab.label}
              {isActive && (
                <>
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: -12,
                      width: "12px",
                      height: "12px",
                      backgroundColor: "#2194D2",
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        backgroundColor: "white",
                        borderBottomRightRadius: index === 0 ? "0px" : "6px",
                        zIndex: 2,
                      }}
                    ></div>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: -12,
                      width: "12px",
                      height: "12px",
                      backgroundColor: "#2194D2",
                      zIndex: 2,
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        backgroundColor: "white",
                        borderBottomLeftRadius: "6px",
                      }}
                    ></div>
                  </div>
                </>
              )}
            </span>
          );
        })}
      </Stack>

      <Stack
        sx={{
          backgroundColor: "#2194D2",
          borderRadius: "6px",
          borderTopLeftRadius: activeTab === "sales" ? "0px" : "6px",
          paddingTop: "3px",
        }}
      >
        <Stack
          sx={{
            backgroundColor: "white",
            borderRadius: "6px",
            border: "1px solid #2194D2",
          }}
        >
          {items.map((item) => {
            if (item.campaign_purpose === activeTab)
              return <ProductListItem key={item.id} product={item} />;
            return null;
          })}
        </Stack>
      </Stack>
    </Stack>
  );
};
